const postal = require('postal');
const _ = require('lodash');

/// getUniqueProducts: argument placements expected to be an array data type
//  with the following defined shape [{ "placement_name": "homepage.rr1", items: [{ "id": "12342" }] }]
/// returns a unique array of productIds: string[] e.g. ["12342", "..."];
function getUniqueProductIds(placements) {
    if (_.isUndefined(placements) || _.isNull(placements)) return [];
    return _.chain(placements).map('items').flatten().uniq('id').map('id').value();
}

function getPlacementIds(placements) {
    return _.map(placements, 'placement_name');
}

function getProductSku($location) {
    const sku = $location.$$path.replace(/\/product\/(\d+)\/.*/, '$1');
    return sku;
}

function isProductDetailsPage($location) {
    return $location.$$path.startsWith('/product/');
}

function publish(placementName, placeholder, decorateAdditionalDetails, productsToShow, productsCollection) {
    postal.publish({
        channel: 'richer-relevance-placeholder',
        topic: `placement.${placementName}`,
        data: {
            title: placeholder.message,
            products: decorateAdditionalDetails(productsToShow),
            placeholder: placementName.toLowerCase(),
            productsCollection
        }
    });
}

function populatePlacement(placementIdentifiers, placements, productIds, defaultProducts, RR, decorateAdditionalDetails, productsCollection) {
    _.forEach(placementIdentifiers, (placementName) => {
        const placeholder = _.find(placements, { placement_name: placementName });
        if (!!placeholder) {
            // TODO: use lodash's intersectBy when we finally upgrade to 4.11
            const productsToShow = _.map(productIds, (stockCode) => {
                const product = _.find(defaultProducts, { Stockcode: parseInt(stockCode, 10) });

                // find link Url for each product in collection
                if (!!RR.data.JSON.placements) {
                    const RRitem = _.find(_.find(RR.data.JSON.placements, { placement_name: placementName }).items, { id: stockCode });
                    if (RRitem && RRitem.linkURL) {
                        product.linkURL = RRitem.linkURL;
                    }
                }

                return product;
            });
            publish(placementName, placeholder, decorateAdditionalDetails, productsToShow, productsCollection);
        }
    });
}

function processResponse(productsCollection, placements, searchService, RR, decorateAdditionalDetails) {
    if (productsCollection) {
        const placementIdentifiers = getPlacementIds(placements);
        const defaultProducts = searchService.transformProductsToDefault(productsCollection);
        const productIds = _.chain(defaultProducts).map('Stockcode').map((code) => '' + code).value();
        populatePlacement(placementIdentifiers, placements, productIds, defaultProducts, RR, decorateAdditionalDetails, productsCollection);
    }
}

const isRRDisplayEnabled = window.config.RR_isEnabled === 'true' ? true : false;

function PlacementNotification(Restangular, decorateAdditionalDetails, $window, $log, searchService, $location) {

    const { RR } = $window;

    if (_.isUndefined(RR)) {
        $log.warn('Richer Relevance not initialized');
        return;
    }

    if (!isRRDisplayEnabled) {
        return;
    }

    RR.jsonCallback = function () {
        const { placements } = RR.data.JSON;
        const stockCodes = getUniqueProductIds(placements);

        if (isProductDetailsPage($location)) {
            const sku = getProductSku($location);
            const productList = Restangular.one('Shopper/ProductDetailsPlacement1');
            productList.get({ stockcodes: stockCodes.join(','), Sku: sku }).then((productsCollection) => {
                processResponse(productsCollection, placements, searchService, RR, decorateAdditionalDetails);
            });
        } else {
            if (stockCodes.length > 0) {
                // important we make one single API call to get all the relevant product data
                const productList = Restangular.one('Products/Bundles/', stockCodes.join(','));
                productList.get({ excludeUnavailable: true }).then((productsCollection) => {
                    processResponse(productsCollection, placements, searchService, RR, decorateAdditionalDetails);
                });
            }
        }
    };
}

module.exports = PlacementNotification;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-placement-notification.js
 **/